export interface GenesysData {
  callID: string;
  phoneNumber: string;
  callType: CallType;
  callSubType: CallSubType;
  ani?: string;
  dialerCampaignId?: string;
  dialerContactListId?: string;
  dialerContactId?: string;
  accountNumber?: any;
}

export interface ThirdPartyCalledData {
  Name: string;
  Mobile: string;
  Office: string;
  Email: string;
  Active: boolean;
  DeactivatedBy: string | null;
  DeactivatedDate: string | null;
  ContactDetails: ContactDetailsItem[];
}

export interface ContactDetailsItem {
  id: number;
  name: string;
  mobile: string;
  office: string;
  email: string;
}

export enum CallType {
  Outbound = 'Outbound',
  Inbound = 'Inbound',
}

export enum CallSubType {
  Dialler = 'Dialler',
  Agent = 'Agent',
}

export interface PhoneSearchData {
  PartyId: number;
  PhoneNumber: string;
  CustomerName: string;
  AccountRef: string;
  AccountId: number;
  DateOfBirth: string;
  Address: string;
  Relationship: string;
}

export interface SearchData {
  General: SearchResultData;
  ID_V_Prompt: SearchResultData;
}

export interface SearchTableData {
  fields: Record<string, unknown>;
  id: number;
  scopeId: number;
}

export interface SearchResultData {
  name?: string;
  displayName?: {
    en: string;
    es: string;
  };
  type?: string;
  colSpan?: number;
  rowSpan?: number;
  data: {
    columns: Column[];
    rows: Row[];
  };
}

export interface Column {
  name: string;
  type: string;
  displayName: {
    en?: string;
    es?: string;
    En?: string;
    Es?: string;
  };
  editable?: string;
  options?: Option[];
  optionsRef?: string;
}

export interface Option {
  name: string;
  displayName: {
    en: string;
    es: string;
  };
  children?: Option[];
}

export interface Row {
  [key: string]: RowValue;
}

export interface RowValue {
  value?: any;
  extraData?: any;
}

export interface GeneralForm {
  fields: {
    [key: string]: {
      name: string;
      type: string;
      displayName: {
        en: string;
        es: string;
      };
      value: string | number | boolean | null;
      extraData: any;
    };
  };
}

export interface IdentificationAndVerificationForm {
  fields: {
    [key: string]: {
      name: string;
      type: string;
      displayName: {
        en: string;
        es: string;
      };
      value: string;
      validation: 'Valid' | 'Invalid' | 'NA';
    };
  };
}

export interface Prompts {
  fields: {
    [key: string]: {
      name: string;
      type: string;
      displayName: {
        en: string;
        es: string;
      };
      value: string;
      validation: 'NA';
    };
  };
}

export interface ReportData {
  scopeId: number;
  entityId: number;
  category: string;
  subEntityId: number;
  activityText: string;
  entityType: string;
  callLog: CallLog;
}

export interface CallLog {
  id: number;
  type: CallType;
  subtype: CallSubType;
  idVStatus: IdVStatus;
  successfulContact: SuccessfulContact;
  customerId: number;
  linkedAccounts: number[];
  additionalFields: AdditionalFields;
  content: Content[];
  telephoneNote: string;
  callSummary: string;
  callSummaryEdited: string;
  callClosure: string;
  callId: string;
  phoneNumber: string;
}

export enum IdVStatus {
  Uncompleted = 'Uncompleted',
  Passed = 'Passed',
  Failed = 'Failed',
}

export enum SuccessfulContact {
  Yes = 'Yes',
  No = 'No',
}

export interface LinkedAccount {
  accountId: number;
  accountRef: string;
  selected: boolean;
}

export interface AdditionalFields {
  [key: string]: any;
}

export interface Content {
  type: string;
  fieldDataType: string;
  textId: string;
  answer: string;
  result: ContentResult;
}

export enum ContentResult {
  NA = 'NA',
  Valid = 'Valid',
  Invalid = 'Invalid',
}

export interface ContactListData {
  contactListId: string;
  contactId: string;
}

export interface GenesysContactData {
  id: string;
  contactListId: string;
  accountNumber: string;
  data: {
    AccountNo: string;
    Customer: string;
    Phone: string;
  };
}

export interface ContactInformation {
  accountNumber: string;
}
